import { getNamespacedBy } from '@/store/utils'

export const actionTypes = {
  FETCH_CATEGORIES_BY_MODALITY_ID: 'fetchCategoriesByModalityId'
}

export const globalActions = getNamespacedBy('category', actionTypes)
